import React from "react";
import { ModalWrapper } from "src/shared/components/ModalWrapper";
import CommonButtons from "src/shared/components/CommonButtons";
import { ConfigModalLayoutProps } from "../types";

const ConfigModalLayout: React.FC<ConfigModalLayoutProps & { confirmDisabled?: boolean }> = ({
  open,
  onClose,
  title,
  children,
  confirmLabel = "Confirm",
  confirmVariant = "primary",
  onConfirm,
  confirmDisabled = false,
}) => {
  if (!open) return null;

  return (
    <ModalWrapper title={title} showCloseButton onClose={onClose} useTheme organizationName="myOrg" width="max-w-lg">
      <div className="flex flex-col gap-4">
        {children}
        <div className="flex justify-center gap-4 mt-4">
          <CommonButtons label="Cancel" variant="cancel" onClick={onClose} size="md" className="w-36" />
          <CommonButtons label={confirmLabel} variant={confirmVariant} onClick={onConfirm} size="md" className="w-36" disabled={confirmDisabled} />
        </div>
      </div>
    </ModalWrapper>
  );
};

export default ConfigModalLayout;
